import script from "./electronics.vue?vue&type=script&setup=true&lang=js"
export * from "./electronics.vue?vue&type=script&setup=true&lang=js"

import "./electronics.vue?vue&type=style&index=0&id=26e85082&lang=scss"

const __exports__ = script;

export default __exports__